module.exports = __webpack_public_path__ + "static/media/linkedin_icon.56ab00e8.png";